import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobolErrorHandlerService implements ErrorHandler {
  handleError(error: any): void {
    const message = error?.message || '';

    const isChunkError = message.includes('Loading chunk') ||
      message.includes('ChunkLoadError') ||
      /chunk \d+ failed/i.test(message) ||
      message.includes('Loading CSS chunk');

    if (isChunkError) {
      console.warn('🧩 Detected chunk load error. Reloading...');
      setTimeout(() => {
        window.location.reload(); // small delay helps browser flush logs
      }, 200);
    } else {
      // Optional: log all other errors
      console.error('🌐 Global Error:', error);
    }
  }
}
